import * as React from 'react';
import { observer } from 'mobx-react';

// Declarations
import { IPeopleItem } from './AppNetworkPeopleSearch';

// Components
import Box from '../../components/Box';
import Container from '../../components/Container';
import Grid from '../../components/Grid';
import { CircularProgress } from '../../components/Progress';

import PeopleListItem from './PeopleListItem';

//
export interface IProps {
    people: IPeopleItem[] | null;
    onSelect: (item: IPeopleItem) => () => void;
}
function MainContent(props: IProps) {
    if (props.people === null) {
        return (<Box mt={5} align="center"><CircularProgress /></Box>);
    }
    return (
        <Container size="lg">
            <Grid container={true}>
                {
                    props.people.map((item, i) => (
                        <Grid key={item.userId} item={true} lg={3} md={4} sm={6} xs={12}>
                            <PeopleListItem
                                user={item}
                                onClick={props.onSelect(item)}
                            />
                        </Grid>
                    ))
                }
            </Grid>
        </Container>
    );
}

export default observer(MainContent);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleSearch/PeopleList.tsx